import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { assert } from "@/common/assert";
import { fhtCommonEnv } from "@/common/fhtGlobalEnv";
import { fhtStorage } from "@/pages/base/fhtStorage";
import { FHTChatId } from "@/common/FHTChatId";
var ITEM_SEP = ",";
var PAIR_SEP = ":";

function makeSavedContactConvIdsKey(myself) {
  return fhtCommonEnv.AppEnv + ":" + myself.clientId + ":contactConvIds_v1";
}

export function loadContactPersistedContactInfoFromStorage(myself) {
  return __awaiter(this, void 0, Promise, function () {
    var contactConvIdsValue, res, convIdAndchatIds, convIdAndchatIds_1, convIdAndchatIds_1_1, s, tokens, _a, convId, encodedChatId, chatId, pi;

    var e_1, _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          return [4
          /*yield*/
          , fhtStorage.getItem(makeSavedContactConvIdsKey(myself))];

        case 1:
          contactConvIdsValue = _c.sent();
          res = [];

          if (contactConvIdsValue) {
            convIdAndchatIds = contactConvIdsValue.split(ITEM_SEP);

            try {
              for (convIdAndchatIds_1 = __values(convIdAndchatIds), convIdAndchatIds_1_1 = convIdAndchatIds_1.next(); !convIdAndchatIds_1_1.done; convIdAndchatIds_1_1 = convIdAndchatIds_1.next()) {
                s = convIdAndchatIds_1_1.value;
                assert(s && s.includes(PAIR_SEP));
                tokens = s.split(PAIR_SEP);
                assert(tokens.length === 2, "s split tokens not of length 2: " + s);
                _a = __read(tokens, 2), convId = _a[0], encodedChatId = _a[1];
                chatId = FHTChatId.decode(encodedChatId);
                pi = {
                  convId: convId,
                  chatId: chatId
                };
                res.push(pi);
              }
            } catch (e_1_1) {
              e_1 = {
                error: e_1_1
              };
            } finally {
              try {
                if (convIdAndchatIds_1_1 && !convIdAndchatIds_1_1.done && (_b = convIdAndchatIds_1["return"])) _b.call(convIdAndchatIds_1);
              } finally {
                if (e_1) throw e_1.error;
              }
            }
          }

          return [2
          /*return*/
          , res];
      }
    });
  });
}
var MAX_PERSISTED_CHAT_COUNT = 50;
export function saveContactsToStorage(myself, contacts) {
  return __awaiter(this, void 0, Promise, function () {
    var sortedContacts, convIds;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          assert(myself, "myself falsy");
          assert(contacts, "contacts falsy");
          sortedContacts = contacts.sort(function (a, b) {
            return b.lastUpdated.getTime() - a.lastUpdated.getTime();
          });
          convIds = sortedContacts.map(function (c) {
            return "" + c.convId + PAIR_SEP + c.chatId.encode();
          }).slice(0, MAX_PERSISTED_CHAT_COUNT).join(ITEM_SEP);
          return [4
          /*yield*/
          , fhtStorage.setItem(makeSavedContactConvIdsKey(myself), convIds)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          ];
      }
    });
  });
}